export class MenuScrollBehavior {
  constructor() {
    this.menuScrollContainerHeight = 0;
    this.sections = [];
    this.unbindSections = [];
  }

  init = () => {
    this.getContainerClientHeight();

    if (this.menuScrollContainerHeight > 0) {
      this.defineActiveMenu();
    }
  };

  getContainerClientHeight = () => {
    const activeMenu = document.querySelector('.menu-syndicated__body-item--active');
    if (activeMenu) {
      this.getContainerClientHeightForMenu(activeMenu);
    }
  };

  /* eslint-disable class-methods-use-this */
  removeTabIndex = (menuItem) => {
    const scrollContainer = menuItem.querySelector('.menu-syndicated__body-scroll');
    if (scrollContainer) {
      scrollContainer.removeAttribute('tabindex');
    }
  };
  /* eslint-enable class-methods-use-this */

  defineActiveMenu = () => {
    const activeMenu = document.querySelector('.menu-syndicated__body-item--active');
    const nonActiveMenus = document.querySelectorAll('.menu-syndicated__body-item:not(.menu-syndicated__body-item--active)');

    if (activeMenu) {
      this.sections = activeMenu.querySelectorAll('.menu-syndicated__section');
      this.defineSectionItemsPositions();
      this.getContainerClientHeightForMenu(activeMenu);
    }

    nonActiveMenus.forEach((menu) => {
      this.unbindSections = menu.querySelectorAll('.menu-syndicated__section');
      this.unDefineSectionItemsPositions();
      this.removeTabIndex(menu);
    });
  };

  getContainerClientHeightForMenu = (menuItem) => {
    const scrollContainer = menuItem.querySelector('.menu-syndicated__body-scroll');
    if (scrollContainer) {
      this.menuScrollContainerHeight = scrollContainer.clientHeight;
      if (scrollContainer.scrollHeight > scrollContainer.clientHeight) {
        scrollContainer.setAttribute('tabindex', '0');
      }
    }
  };

  defineSectionItemsPositions = () => {
    const { sections } = this;

    this.sections.forEach((section, index) => {
      const sectionHeight = section.clientHeight;
      this.stickSection(sectionHeight, section);

      if (index === sections.length - 1) {
        this.prepareLastSection(sectionHeight, section, sections);
      }
    });
  };

  unDefineSectionItemsPositions = () => {
    const { unbindSections } = this;
    unbindSections.forEach((section) => {
      section.removeAttribute('style');
      section.classList.remove('menu-syndicated__section--sticky');
    });
  };

  stickSection = (sectionHeight, section) => {
    const { menuScrollContainerHeight } = this;

    if (sectionHeight < menuScrollContainerHeight) {
      section.classList.add('menu-syndicated__section--sticky');
    } else {
      const scrollHeight = sectionHeight - menuScrollContainerHeight;
      // eslint-disable-next-line no-param-reassign
      section.style.position = 'sticky';
      // eslint-disable-next-line no-param-reassign
      section.style.top = `-${scrollHeight}px`;
    }
  };

  prepareLastSection = (sectionHeight, section) => {
    const { sections } = this;

    if (sections[sections.length - 2]) {
      const sectionItem = sections[sections.length - 2];
      this.setMinHeightForLastSection(sectionItem, section, sectionHeight);
    }
  };

  setMinHeightForLastSection = (sectionItem, section, sectionHeight) => {
    const { menuScrollContainerHeight } = this;

    if (sectionHeight >= menuScrollContainerHeight - sectionItem.clientHeight) {
      // eslint-disable-next-line no-param-reassign
      section.style.minHeight = `${menuScrollContainerHeight}px`;
    }

    if (sectionHeight + sectionItem.clientHeight < menuScrollContainerHeight) {
      // eslint-disable-next-line no-param-reassign
      section.style.minHeight = `${sectionHeight + menuScrollContainerHeight - sectionHeight - sectionItem.clientHeight}px`;
    }
  };
}
